import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { Products, UpdateProductCountEvent } from '@/api/product';

export default abstract class ProductListAbstract extends Vue {
    @Prop({ default: () => [] }) products!: Products
    @Prop({ default: true }) loading!: Boolean
    @Prop({ default: '' }) unsecured!: String
    dialog = false
    addedItem = null
    noResultsText = 'Нет результатов, удовлетворяющих параметрам поиска.'
    get noDataText() {
        return this.loading ? 'Идет поиск...' : this.noResultsText
    }
    showDialog(e: boolean) {
        this.dialog = e
    }
    updateProductCount(e: UpdateProductCountEvent) {
        this.$emit('updateProductCount', e)
    }
    deleteUnsecuredItem(e: string) {
        this.$emit('deleteUnsecuredItem', e)
    }
}